import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { MobileConfirmationComponent } from 'app/portal/shared/mobile-confirmation/mobile-confirmation.component';
import { AccountService } from '../services/services.module';
import { OpenDialog } from './dialogs/dialog';

@Injectable()
export class MobileConfirmationPopup implements CanActivate {
  constructor(private router: Router, private accountService: AccountService) {}

  async canActivate() {
    if (this.accountService.currentUser) {
      if (!this.accountService.currentUser.mobileVerified && this.accountService.currentUser.mobilePhoneCountryCode === '94') {
        let result = await OpenDialog(MobileConfirmationComponent);
        return result;
      }
      return true;
    } else {
      return this.accountService
        .loadCurrentUserFromServer()
        .then(async (data) => {
          if (this.accountService.currentUser) {
            if (!this.accountService.currentUser.mobileVerified && this.accountService.currentUser.mobilePhoneCountryCode === '94') {
              let result = await OpenDialog(MobileConfirmationComponent);
              if (result) {
                return result;
              } else {
                this.router.navigate(['/']);
              }
            }
            return true;
          }
        })
        .catch(() => {
          return false;
        });
    }
  }
}
